import { render, staticRenderFns } from "./pop-payment.vue?vue&type=template&id=648614ff&scoped=true"
import script from "./pop-payment.vue?vue&type=script&lang=js"
export * from "./pop-payment.vue?vue&type=script&lang=js"
import style0 from "./pop-payment.vue?vue&type=style&index=0&id=648614ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648614ff",
  null
  
)

export default component.exports